module.exports = __webpack_public_path__ + "img/indeterminate.c342e4d1.svg";